<template>
<div class="spackageContentEdit form dialog-form">
    <el-dialog title="分享设置" :visible.sync="dialogFormVisible" width="600px">
        <el-form :model="item" label-width="120px" class="demo-ruleForm" label-position="left" size="mini">
            <el-form-item label="分享标题">
                <el-input v-model="item.name" auto-complete="off" placeholder="请输入目录名称，不超过30字。"></el-input>
            </el-form-item>
            <el-form-item label="分享描述">
                <el-input type="textarea" v-model="item.name" :rows="4" placeholder="请输入简介，不超过80字。"></el-input>
            </el-form-item>
            <el-form-item label="分享封面" class="upload-image">
                <upload class="shareImage" :imgRule="imgRule"></upload>
                <div class="el-upload__tip">建议上传尺寸500*390</div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
export default {
    name: 'spackageContentEdit',
    data() {
        return {
            item: {
                name: '',
                imgUrl: ''
            },
            dialogFormVisible: false,
            imgRule: {
                cls: '',
                accept: 'image/png,image/jpeg,image/gif',
                size: 2,
                width: 500,
                height: 390
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(row) {
            this.dialogFormVisible = true
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Upload
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.spackageContentEdit {
    .upload-image{
        .el-form-item__content{
            @include flexBox(flex-start)
        }
        .shareImage .avatar-uploader{
            box-sizing: border-box;
            width: 120px;
            height: 90px;
        }
        .el-upload__tip{
            margin-left: 10px;
            align-self: flex-end;
        }
    }
}
</style>
